import React from 'react'
import useTranslations from 'src/hooks/useTranslations'

/**
 * HOC-wrapper around our custom useTranslations hook.
 * This consumes the mikado translation-provider if it's available, and falls back to the given `fallbackNamespace`
 * @param fallbackNamespace
 * @param componentName
 * @returns {function(*): React.ForwardRefExoticComponent<React.PropsWithoutRef<{}> & React.RefAttributes<unknown>>}
 */
export default function withTranslations(fallbackNamespace, componentName) {
    return function (Component) {
        const WithTranslationsWrapper = React.forwardRef(
            function WithTranslationsForwarder(props, ref) {
                const { t, i18n } = useTranslations(
                    fallbackNamespace,
                    componentName
                )

                return <Component {...props} t={t} i18n={i18n} ref={ref} />
            }
        )
        WithTranslationsWrapper.displayName = `withTranslations(${
            componentName ?? Component.displayName ?? Component.name
        })`
        return WithTranslationsWrapper
    }
}
